import React from 'react';
import '../Styles/refund.css';

const Refund = () => {
  return (
    <div className="refund-page-wrapper">
      <div className="refund-container">

        <h1 className="refund-title">
          Refund <span className="refund-title-highlight">Policy</span>
        </h1>

        <p className="refund-intro">
          At Vanakkam HRD, we strive to deliver a seamless experience for all our participants, members, sponsors, and partners. Please read our refund policy carefully before making any payment.
        </p>

        <section className="refund-section">
          <h2 className="refund-heading">Event Registrations</h2>

          <ul className="refund-list">
            <li>All event registration fees are non-refundable.</li>
            <li> ⁠Registrations cannot be canceled once payment has been successfully completed.</li>
            <li>⁠If an event is postponed or rescheduled, your registration will remain valid for the new date.</li>
            <li>⁠If an event is canceled by Vanakkam HRD, eligible participants will be notified regarding refund or credit options.</li>
          </ul>
        </section>

        <section className="refund-section">
          <h2 className="refund-heading">Memberships &amp; Certifications</h2>

          <p className="refund-text">
            Membership, certification, nomination, and application fees are non-refundable once processed.
          </p>
        </section>

        <section className="refund-section">
          <h2 className="refund-heading">Sponsorships</h2>

          <p className="refund-text">
           Sponsorship and partnership payments are non-refundable unless otherwise specified in a signed agreement.
          </p>
        </section>

        <section className="refund-section">
          <h2 className="refund-heading">Payment Errors</h2>

          <p className="refund-text">
           If you believe you have been charged incorrectly or made a duplicate payment, please contact us within 7 days of the transaction. After verification, eligible refunds will be processed to the original payment method.
          </p>
        </section>

        <section className="refund-section refund-section-last">
          <h2 className="refund-heading">Contact Us</h2>

          <p className="refund-text">
           For any refund-related queries, please contact our support team through the Contact Us page or email us at support@vanakkamhrd.com
          </p>
        </section>

      </div>
    </div>
  );
};

export default Refund;